enum SyncProgressStatus {
  COMPLETED = "completed",
  IDLE = "idle",
  IN_PROGRESS = "in_progress",
}

export default SyncProgressStatus;
